import { Phone, Zap, MoonStar, PhoneCall } from "lucide-react";
import { Reveal } from "./Reveal";
import { ChatPanel } from "./ChatPanel";
import { TELEFONO, TELEFONO_HREF } from "@/data/citta";

const PUNTI = [
  { icon: Zap, testo: "Risponde un operatore reale, in pochi minuti" },
  { icon: MoonStar, testo: "Attiva 24 ore su 24, anche di notte e nei festivi" },
  { icon: PhoneCall, testo: "Lasci il numero e ti richiamiamo noi" },
];

export function ChatSezione() {
  return (
    <section
      id="chat"
      className="relative overflow-hidden border-b border-slate-800 py-24 md:py-32"
    >
      <div className="pointer-events-none absolute left-1/2 top-0 h-[480px] w-[820px] -translate-x-1/2 rounded-full bg-amber-500/10 blur-[140px]" />
      <div className="pointer-events-none absolute -right-40 bottom-0 h-96 w-96 rounded-full bg-emerald-500/5 blur-[120px]" />

      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal className="text-center">
            <span
              data-testid="chat-sezione-badge-live"
              className="inline-flex items-center gap-2.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-5 py-2.5"
            >
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-400" />
              </span>
              <span className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-400">
                Chat attiva ora
              </span>
            </span>
            <h2 className="mx-auto mt-7 max-w-xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-white text-balance sm:text-5xl">
              Parli con un operatore{" "}
              <span className="text-amber-400">in diretta,</span>
              <br />
              non con un robot.
            </h2>
            <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-slate-300 sm:text-lg">
              Descrivici l'emergenza dalla chat qui accanto: leggiamo e rispondiamo sul
              serio, subito. Niente attese al telefono, niente moduli infiniti.
            </p>
            <ul className="mx-auto mt-9 max-w-md space-y-4">
              {PUNTI.map((p) => (
                <li
                  key={p.testo}
                  className="flex items-center justify-center gap-3 text-sm text-slate-200 sm:text-base"
                >
                  <span className="rounded-lg bg-amber-500/15 p-2 text-amber-400">
                    <p.icon size={17} />
                  </span>
                  {p.testo}
                </li>
              ))}
            </ul>
            <a
              href={TELEFONO_HREF}
              data-testid="chat-sezione-cta-telefono"
              className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-amber-500 px-8 py-4 text-base font-bold text-obsidian transition-all hover:-translate-y-0.5 hover:bg-amber-400 hover:shadow-[0_12px_40px_rgba(245,158,11,0.35)]"
            >
              <Phone size={18} strokeWidth={2.5} />
              Preferisci parlare? {TELEFONO}
            </a>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative mx-auto max-w-lg">
              <div className="absolute -inset-4 rounded-[28px] bg-gradient-to-br from-amber-500/30 via-transparent to-emerald-500/10 blur-xl" />
              <span
                data-testid="chat-sezione-badge-operatori"
                className="absolute -top-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full border border-emerald-500/40 bg-obsidian px-5 py-2 text-xs font-semibold text-emerald-400 shadow-[0_8px_30px_rgba(0,0,0,0.5)]"
              >
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
                </span>
                Operatori online ora
              </span>
              <div className="relative rounded-[22px] bg-gradient-to-br from-amber-500/70 via-slate-700/40 to-amber-500/20 p-[1.5px] shadow-[0_30px_90px_rgba(245,158,11,0.18)]">
                <div className="h-[560px] overflow-hidden rounded-[20px] bg-obsidian">
                  <ChatPanel prefisso="chat-sezione" />
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
